// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1DF1f","close":"modal_close__1Iez6"};